"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getenv(field) {
    var _a;
    const value = (_a = process === null || process === void 0 ? void 0 : process.env[field]) !== null && _a !== void 0 ? _a : window === null || window === void 0 ? void 0 : window.env[field];
    if (value === undefined) {
        throw new Error(`Missing env variable [${field}]`);
    }
    return value;
}
exports.default = getenv;
